<div class="common-lateral-panel common-lateral-panel--grey"
  [ngClass]="{'common-lateral-panel--expand':conceptLegalDocumentation.fullScreen}">
  <div class="common-section-title__lp-container-sidemenu">
    <div class="common-section-title__lp-container-title">
      <div class="common-section-title__lp-title-icon">
        <i class="lf-icon-legal-reference common-icon__lg"
          [ngClass]="{'common-icon__main': !isLanding}"></i>
        <span class="common-section-title__lp-label-text"
          [afTranslate]="'law-info.legal-references'">Documentación jurídica</span>
      </div>
    </div>
    <div class="common-section-title__lp-container-subtitle">
      <span [afTranslate]="isLanding?'concept-form.title-legal-concept-documentation':'predefined-templates.document-generate'">_Consulta la información relacionada con el concepto/Genera tus documentos a partir de plantillas predefinidas</span>
    </div>
  </div>
  <div class="common-lateral-panel__body">
    <ul class="common-lateral-panel__list-items">
      @for (reference of referencesList; track $index) {
        <li [ngClass]="isLanding?'common-lateral-panel__item-cursor-grey-landing':'common-lateral-panel__item-cursor'"
          (click)="showLegalDocumentation($event, reference)">
          <i [class]="(reference.type | typeIcons:'reference') +' common-icon__md common-icon__main'"></i>
          <span-tooltip class="common-lateral-panel__item-text common-lateral-panel__item-text--flex"
            [text]="reference.text"></span-tooltip>
        </li>
      }
    </ul>
  </div>
  <div class="common-lateral-panel__expand-block"
    [ngShow]="referencesList?.length > 3">
    <div class="common-lateral-panel__expand-total-block">
      <p class="common-lateral-panel__expand-total-text">
        <span [afTranslate]="'common.total'">_Total</span>
        <span class="pr-1">:</span>
        <span>{{referencesList?.length}}</span>
      </p>
    </div>
    <button class="common-button__expand-toned"
      (click)="conceptLegalDocumentation.fullScreen = !conceptLegalDocumentation.fullScreen">
      <i class=" common-icon__md"
      [ngClass]="conceptLegalDocumentation.fullScreen? 'lf-icon-angle-up': 'lf-icon-angle-down'"></i>
      <span class="common-button__expand-label-text">{{conceptLegalDocumentation.fullScreen? 'Colapsar':'Expandir'}}</span>
    </button>
  </div>
</div>
